import HotelRewardsOverview from "@/components/RewardsOverview/HotelRewardsOverview";
import React from "react";
import ReactDOM from "react-dom";

function mountHotelRewardsOverview() {
  const el = document.getElementById("hotel-rewards-overview");
  const propsScript = document.getElementById("hotel-rewards-overview-props");

  if (el && !el.dataset.reactMounted && propsScript) {
    try {
      const props = JSON.parse(propsScript.textContent || "{}");
      ReactDOM.render(React.createElement(HotelRewardsOverview, props), el);
      el.dataset.reactMounted = "true";
    } catch (e) {
      console.error("Failed to parse props JSON:", e);
    }
  }
}

document.addEventListener("turbo:render", mountHotelRewardsOverview);
document.addEventListener("DOMContentLoaded", mountHotelRewardsOverview);
mountHotelRewardsOverview();
